import { Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { StorageService } from "../services/storage.service";
import { Geolocation, Geoposition } from '@ionic-native/geolocation/ngx';
import { Metadata } from "src/app/base/model/data-body-request";
import { ProcessedDataResponse } from "./model/processed-data-response";
import { AuthService } from "../guards/auth.service";
import { PagesToNavigateService } from "./pages.service";

export abstract class BaseComponent {
    constructor(
        protected loadingCtrl: LoadingController,
        protected router: Router,
        protected storageService: StorageService,
        protected alertController: AlertController,
        protected authService: AuthService,
        protected pagesToNavigateService: PagesToNavigateService
    ) {
        this.getGeolocation()
        try { this.deviceName = (window as any).device.name } catch { this.deviceName = "web" };
    }

    protected latitude: number = 0;
    protected longitude: number = 0;
    protected accuracy: number = 0;
    protected deviceName: any = "web";

    protected menu
    protected appPages$ = this.pagesToNavigateService.pages$;

    protected buildMenu(permissionAllowedToSearch: string) {
        if (permissionAllowedToSearch === "true") {
            return [
                {
                    url: '/dashboard',
                    icon: 'home-outline',
                    title: 'Inicio'
                },
                {
                    url: '/enrollment/search',
                    icon: 'search',
                    title: 'Búsqueda cliente'
                }
            ];
        } else {
            return [
                {
                    url: '/dashboard',
                    icon: 'home-outline',
                    title: 'Inicio'
                }
            ];
        }
    }

    protected async showLoading() {
        this.loadingCtrl.getTop().then(hasLoading => {
            this.loadingCtrl.create({
                spinner: 'circular',
                translucent: true
            }).then(loading => loading.present());
        });
    }

    protected async closeLoader() {
        // Instead of directly closing the loader like below line
        // return await this.loadingController.dismiss();

        this.checkAndCloseLoader();

        // sometimes there's delay in finding the loader. so check if the loader is closed after one second. if not closed proceed to close again
        setTimeout(() => this.checkAndCloseLoader(), 1000);

    }

    private async checkAndCloseLoader() {
        // Use getTop function to find the loader and dismiss only if loader is present.
        const loader = await this.loadingCtrl.getTop();
        // if loader present then dismiss
        if (loader !== undefined) {
            await this.loadingCtrl.dismiss();
        }
    }

    protected logout(): void {
        this.authService.logout();
        this.router.navigateByUrl('/login', { replaceUrl: true }).then();
    }

    protected navigateTo(urlNavigation: string) {
        this.router.navigateByUrl(urlNavigation, { replaceUrl: true }).then();
    }

    protected getGeolocation() {
        let options = { timeout: 10000, enableHighAccuracy: true, maximumAge: 3600 };
        new Geolocation().getCurrentPosition(options).then((geoposition: Geoposition) => {
            this.latitude = geoposition.coords.latitude;
            this.longitude = geoposition.coords.longitude;
            this.accuracy = geoposition.coords.accuracy;
            console.log("Lat: " + this.latitude)
            console.log("Lon: " + this.longitude)
            console.log("Acc: " + this.accuracy)

        },
            // Here is the error catching that needs to be added
            err => {
                console.log(' Error Geolocation: ' + JSON.stringify(err));
            });
    }

    protected async presentAlert(title: string, message: string, isTwoButtons: boolean, onAccept?: () => void) {
        const alert = await this.alertController.create({
            header: title,
            message: message,
            mode: "ios",
            backdropDismiss: false,
            buttons: isTwoButtons ? [
                {
                    text: 'Cancelar',
                    role: 'cancel',
                    cssClass: 'secondary',
                }, {
                    text: 'Aceptar',
                    handler: onAccept ? () => {
                        onAccept()
                    } : () => {}
                }
            ] : [
                {
                    text: 'Aceptar',
                    handler: onAccept ? () => {
                        onAccept()
                    } : () => {}
                }]
        });
        await alert.present();
    }

    protected buildMetadata(): Metadata {
        var metadata = new Metadata()
        metadata.accuracy = this.accuracy
        metadata.latitude = this.latitude
        metadata.longitude = this.longitude
        metadata.deviceInfo = this.deviceName
        metadata.timeZoneId = 1
        this.storageService.getStorage('userId').then((op: any) => {
            metadata.userId = +op.value
        });
        return metadata
    }


    protected handleResponseData(
        dataResponse: ProcessedDataResponse<any>,
        paramsSuccess: {
            titleMessage: string,
            bodyMessage: string,
            onAcceptSuccess?: () => void,
        }
    ) {
        switch (dataResponse.code) {
            case -9999:
                this.presentAlert(
                    paramsSuccess.titleMessage,
                    paramsSuccess.bodyMessage,
                    false,
                    () => {
                        paramsSuccess.onAcceptSuccess()
                    }
                )
                break;
            default:
                var errorMessage = dataResponse.error || dataResponse.error != '' ? dataResponse.error : 'Error en el servicio, intentar más tarde';
                console.log("Searvice error: " + errorMessage);
                this.presentAlert(
                    'Aviso',
                    errorMessage,
                    false
                );
                break;
        }
    }

    protected handleResponseDataNoMessage(
        dataResponse: ProcessedDataResponse<any>,
        onSuccess?: () => void,
    ) {
        switch (dataResponse.code) {
            case -9999:
                onSuccess()
                break;
            default:
                var errorMessage = dataResponse.error || dataResponse.error != '' ? dataResponse.error : 'Error en el servicio, intentar más tarde';
                console.log("Searvice error: " + errorMessage);
                this.presentAlert(
                    'Aviso',
                    errorMessage,
                    false
                );
                break;
        }
    }
}